module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_photograph_02-4c1f3e8029d64ab7f5f628e820f7f5a6.png";